export default __webpack_public_path__ + "static/media/l3-p6.65542f3c.png";